import {
  AssistantOutlined,
  FactCheckOutlined,
  FolderOutlined,
  InsertDriveFileOutlined,
  RuleOutlined,
  Science as ScienceIcon,
  StoreOutlined,
  MonitorHeart,
} from "@mui/icons-material";
import { BsBucket, BsChat } from "react-icons/bs";

import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CIcon from "@coreui/icons-react";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { determinePlatformType } from "src/reusable/Functions";
import { freeSet } from "@coreui/icons";
import { FeatureFlag } from "src/config/featureFlags";
import {
  isEdgeConnectorsEnabled,
  isObservationProgramEnabled,
  isSmartCrEnabled,
} from "src/config/posthog";

const navElements = () => {
  const navItems = [
    {
      _tag: "CSidebarNavTitle",
      _children: ["Admin"],
      _roles: "admin",
      _navKey: "admin-section",
      name: "ADMIN",
    },
    {
      _tag: "CSidebarNavItem",
      name: <>Jobs</>,
      to: "/jobs",
      _navKey: "jobs",
      icon: (
        <CIcon
          content={freeSet.cilBriefcase}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "job:read",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Mgmt. Console",
      to: "/management-console",
      _navKey: "mgmt-console",
      icon: (
        <CIcon
          content={freeSet.cilStorage}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "admin",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Resource Management",
      to: "/resource-management",
      _navKey: "resource-management",
      icon: (
        <CIcon content={freeSet.cilCog} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "admin",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Hub Settings",
      to: "/hub-settings",
      _navKey: "hub-settings",
      icon: (
        <CIcon
          content={freeSet.cilSettings}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "admin",
      _product: "hub",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Models",
      to: "/models",
      _navKey: "models",
      icon: (
        <CIcon content={freeSet.cilGraph} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "admin",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Users & Groups",
      to: "/users",
      _navKey: "users-groups",
      icon: (
        <CIcon content={freeSet.cilUser} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "admin",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Agent Jobs",
      to: "/admin/agent-jobs",
      _navKey: "agent-jobs",
      icon: (
        <CIcon content={freeSet.cilTask} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "admin",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Edge Connectors",
      to: "/admin/edge-connectors",
      icon: (
        <CIcon
          content={freeSet.cilCloudDownload}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "admin",
      _product: "edge-connectors",
      _enabled: isEdgeConnectorsEnabled,
    },
    {
      _tag: "CSidebarNavItem",
      name: "Agent Sessions",
      to: "/admin/agent-sessions",
      _navKey: "agent-sessions",
      icon: (
        <CIcon
          content={freeSet.cilMediaPlay}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "admin",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Conversation Eval",
      to: "/admin/eval-dashboard",
      _navKey: "conversation-eval",
      icon: (
        <CIcon
          content={freeSet.cilSpeedometer}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "admin",
    },
    {
      _tag: "CSidebarNavTitle",
      _children: ["MARKETPLACE"],
      _roles: "product:read",
      _navKey: "marketplace-section",
      name: "MARKETPLACE",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Agent Market",
      to: "/assistant/persona-marketplace",
      _navKey: "agent-market",
      icon: (
        <CIcon content={freeSet.cilCart} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "admin",
    },
    {
      _tag: "CSidebarNavTitle",
      _children: ["Generative AI"],
      _product: "atom-assist",
      _roles: "product:read",
      _navKey: "generative-ai-section",
      name: "GENERATIVE AI",
    },
    {
      _tag: "CSidebarNavItem",
      name: <>{determinePlatformType()}</>,
      to: "/assistant",
      _navKey: "atomassist",
      _roles: "product:read",
      icon: <BsChat className="c-sidebar-nav-icon" />,
      _product: "atom-assist",
    },
    {
      _tag: "CSidebarNavItem",
      name: <>{determinePlatformType()} Projects</>,
      to: "/assistant/projects",
      _navKey: "projects",
      _roles: "product:read",
      icon: <AccountTreeIcon fontSize="small" className="c-sidebar-nav-icon" />,
      _product: "atom-assist",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Agent Workspace",
      to: "/assistant/workspace",
      _navKey: "agent-workspace",
      _userSetting: "show_agent_workspace",
      _roles: "product:read",
      icon: <FolderOutlined fontSize="small" className="c-sidebar-nav-icon" />,
      _product: "atom-assist",
    },
    {
      _tag: "CSidebarNavItem",
      name: <>50.59 Evaluation</>,
      to: "/fifty-fifty-nine",
      _navKey: "5059-evaluation",
      _roles: "product:read",
      icon: (
        <FactCheckOutlined
          className="c-sidebar-nav-icon"
          sx={{ stroke: "#132E31", strokeWidth: 0.7 }}
        />
      ),
      _product: "licensing-compliance",
    },
    {
      _tag: "CSidebarNavItem",
      name: <>Verifications</>,
      to: "/assistant/verifications",
      _navKey: "verifications",
      _roles: "product:read",
      icon: (
        <RuleOutlined
          className="c-sidebar-nav-icon"
          sx={{ stroke: "#132E31", strokeWidth: 0.7 }}
        />
      ),
      _product: "licensing-compliance",
      _internalOnly: true,
    },
    {
      _tag: "CSidebarNavItem",
      name: <>{determinePlatformType()} Actions</>,
      to: "/assistant/actions",
      _navKey: "actions",
      _roles: "admin",
      icon: (
        <PendingActionsIcon
          className="c-sidebar-nav-icon"
          // sx={{ fontSize: " }}
        />
      ),
      _product: "atom-assist",
    },
    {
      _tag: "CSidebarNavItem",
      name: `${determinePlatformType()} Agents`,
      to: "/assistant/configs",
      _navKey: "agents",
      _roles: "product:read",
      icon: (
        <AssistantOutlined
          className="c-sidebar-nav-icon"
          sx={{ stroke: "#132E31", strokeWidth: 0.7 }}
        />
      ),
      _product: "atom-assist",
    },
    {
      _tag: "CSidebarNavItem",
      name: `${determinePlatformType()} Templates`,
      to: "/assistant/templates",
      _navKey: "templates",
      icon: (
        <InsertDriveFileOutlined
          className="c-sidebar-nav-icon"
          sx={{ stroke: "#132E31", strokeWidth: 0.7 }}
        />
      ),
      _roles: "nuclearn:write",
      _product: "atom-assist",
    },
    {
      _tag: "CSidebarNavItem",
      name: `${determinePlatformType()} Research`,
      to: "/assistant/research",
      _navKey: "research",
      icon: (
        <ScienceIcon
          className="c-sidebar-nav-icon"
          sx={{ stroke: "#132E31", strokeWidth: 0.7 }}
        />
      ),
      _roles: "product:read",
      _product: "atom-assist",
      _featureFlag: FeatureFlag.DEEP_RESEARCH,
    },
    {
      _tag: "WorkflowNavigation",
      _roles: "product:read",
      _product: "atom-assist",
      _navKey: "workflows",
      name: "WORKFLOWS",
    },
    {
      _tag: "CSidebarNavTitle",
      _children: ["Data"],
      _roles: "product:read",
      _navKey: "data-section",
      name: "DATA",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Datasets",
      to: "/datasets",
      _navKey: "datasets",
      icon: (
        <CIcon
          content={freeSet.cilSpreadsheet}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "dataset:read",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Time Series",
      to: "/time-series",
      _navKey: "time-series",
      icon: (
        <CIcon content={freeSet.cilChart} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "timeseries:read",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Dataset Market",
      to: "/datasets/dataset-marketplace",
      _navKey: "dataset-market",
      icon: (
        <StoreOutlined
          className="c-sidebar-nav-icon"
          sx={{ stroke: "#132E31", strokeWidth: 0.7 }}
        />
      ),
      _roles: "dataset:read",
    },
    {
      _tag: "CSidebarNavItem",
      name: "AtomResults",
      to: "/atom-results",
      _navKey: "atom-results",
      icon: (
        <CIcon
          content={freeSet.cilSpreadsheet}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "product:read",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Email Records",
      to: "/email-records",
      _navKey: "email-records",
      icon: (
        <CIcon
          content={freeSet.cilEnvelopeLetter}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "product:read",
    },
    {
      _tag: "CSidebarNavTitle",
      _children: ["Analytics"],
      _roles: "product:read",
      _product: ["cap-ai", "evaluator"],
      _navKey: "analytics-section",
      name: "ANALYTICS",
    },
    {
      _tag: "CSidebarNavItem",
      name: <>Buckets</>,
      to: "/buckets",
      _navKey: "buckets",
      icon: <BsBucket className="c-sidebar-nav-icon" />,
      _roles: "bucket:read",
      _product: ["cap-ai", "evaluator"],
    },
    {
      _tag: "CSidebarNavItem",
      name: <>Reports</>,
      to: "/reports",
      _navKey: "reports",
      icon: (
        <CIcon content={freeSet.cilNotes} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "report:read",
      _product: ["cap-ai", "evaluator"],
    },
    {
      _tag: "CSidebarNavTitle",
      _children: ["Products"],
      _roles: "product:read",
      _navKey: "products-section",
      name: "PRODUCTS",
    },
    {
      _tag: "CSidebarNavItem",
      name: "CAP AI",
      to: "/products/cap-ai",
      _navKey: "cap-ai",
      icon: (
        <CIcon content={freeSet.cilPencil} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "product:read",
      _product: ["cap-ai", "evaluator"],
    },
    {
      _tag: "CSidebarNavItem",
      name: "Smart CR",
      to: "/products/cap-ai/cr",
      _navKey: "smart-cr",
      icon: (
        <CIcon content={freeSet.cilNotes} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "product:read",
      // Smart CR license module plus its rollout flag (same name).
      _product: "smart-cr",
      _enabled: isSmartCrEnabled,
    },
    {
      _tag: "CSidebarNavItem",
      name: "Capitalizer",
      to: "/products/capitalizer",
      _navKey: "capitalizer",
      icon: (
        <CIcon content={freeSet.cilMoney} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "product:read",
      _product: ["capitalizer"],
    },
    {
      _tag: "CSidebarNavItem",
      name: "Observation Program",
      to: "/observation-program",
      _navKey: "observation-program",
      _enabled: isObservationProgramEnabled,
      icon: (
        <CIcon
          content={freeSet.cilMagnifyingGlass}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "product:read",
      _product: ["observation-program"],
    },
    {
      _tag: "CSidebarNavItem",
      name: "OP Dashboard",
      to: "/products/op-dashboard",
      _navKey: "op-dashboard",
      icon: (
        <CIcon
          content={freeSet.cilChartPie}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      // The dashboard's API is admin-only, so the entry is too; only the interview needs the flag and the license.
      _roles: "admin",
    },
    {
      _tag: "CSidebarNavItem",
      name: "OP Chat",
      to: "/observation-program/chat",
      _navKey: "op-chat",
      _enabled: isObservationProgramEnabled,
      icon: (
        <CIcon
          content={freeSet.cilChatBubble}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "product:read",
      _product: ["observation-program"],
    },
    {
      _tag: "CSidebarNavItem",
      name: "Project Genius",
      to: "/products/project-genius",
      _navKey: "project-genius",
      icon: (
        <CIcon
          content={freeSet.cilCalendar}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "project_genius:read",
      _product: ["project-genius"],
    },
    {
      _tag: "CSidebarNavItem",
      name: "Regulatory AI",
      to: "/products/regulatory-ai",
      _navKey: "regulatory-ai",
      icon: (
        <CIcon
          content={freeSet.cilBalanceScale}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "product:read",
      _product: ["regulatory-ai"],
    },
    {
      _tag: "CSidebarNavItem",
      name: "Safety Analytics",
      to: "/products/safety-analytics",
      _navKey: "safety-analytics",
      icon: (
        <CIcon content={freeSet.cilWalk} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "product:read",
      _product: ["safety-analytics"],
    },
    {
      _tag: "CSidebarNavItem",
      name: "Equipment AI",
      to: "/products/equipment-ai",
      _navKey: "equipment-ai",
      icon: <MonitorHeart className="c-sidebar-nav-icon" />,
      _roles: "equipment_ai:read",
      _product: ["equipment_ai"],
    },
    {
      _tag: "CSidebarNavItem",
      name: "Document Intelligence",
      to: "/document-intelligence",
      _navKey: "document-intelligence",
      icon: (
        <CIcon
          content={freeSet.cilDescription}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "product:read",
      _featureFlag: FeatureFlag.DOCUMENT_INTELLIGENCE,
    },
    {
      _tag: "CSidebarNavItem",
      name: "Parts AI",
      to: "/parts",
      _navKey: "parts-ai",
      icon: (
        <CIcon content={freeSet.cilPuzzle} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "product:read",
      _product: "parts-ai",
    },
    {
      _tag: "CSidebarNavItem",
      name: "Proposal Generation",
      to: "/proposal-generation",
      _navKey: "proposal-generation",
      icon: (
        <CIcon content={freeSet.cilPenNib} customClasses="c-sidebar-nav-icon" />
      ),
      _roles: "product:read",
      _product: "proposal-generation",
    },
    {
      _tag: "CSidebarNavItem",
      name: "VNV Assist",
      to: "/vnv-assist",
      _navKey: "vnv-assist",
      icon: (
        <CIcon
          content={freeSet.cilCheckCircle}
          customClasses="c-sidebar-nav-icon"
        />
      ),
      _roles: "product:read",
      _product: "vnv-assist",
    },
  ];

  if (process.env.NODE_ENV !== "production") {
    const developerSection = [
      {
        _tag: "CSidebarNavTitle",
        _children: ["Developer"],
        _roles: "admin",
        name: "DEVELOPER",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Time Series",
        to: "/time-series",
        icon: (
          <CIcon
            content={freeSet.cilChart}
            customClasses="c-sidebar-nav-icon"
          />
        ),
        _roles: "timeseries:read",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Direct Tools",
        to: "/assistant/direct-tools",
        icon: (
          <CIcon content={freeSet.cilCog} customClasses="c-sidebar-nav-icon" />
        ),
        _roles: "product:read",
        _product: "atom-assist",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Design System",
        to: "/demo/design-system",
        icon: (
          <CIcon
            content={freeSet.cilPaint}
            customClasses="c-sidebar-nav-icon"
          />
        ),
        _roles: "admin",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Datasets V2",
        to: "/demo/datasets",
        icon: (
          <CIcon
            content={freeSet.cilStorage}
            customClasses="c-sidebar-nav-icon"
          />
        ),
        _roles: "admin",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Model Control",
        to: "/demo/model-control",
        icon: (
          <CIcon
            content={freeSet.cilSpeedometer}
            customClasses="c-sidebar-nav-icon"
          />
        ),
        _roles: "admin",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Search Eval",
        to: "/developer/search-eval",
        icon: (
          <CIcon
            content={freeSet.cilChart}
            customClasses="c-sidebar-nav-icon"
          />
        ),
        _roles: "admin",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Training Export",
        to: "/developer/training-export",
        icon: (
          <CIcon
            content={freeSet.cilCloudDownload}
            customClasses="c-sidebar-nav-icon"
          />
        ),
        _roles: "admin",
      },
      {
        _tag: "CSidebarNavItem",
        name: "Rollout Gen",
        to: "/developer/rollouts",
        icon: (
          <CIcon
            content={freeSet.cilMediaPlay}
            customClasses="c-sidebar-nav-icon"
          />
        ),
        _roles: "admin",
      },
    ];
    return [...developerSection, ...navItems];
  }

  return navItems;
};

export default navElements;
